import { createElement, type JSX } from "react";

export interface LoadingStateScreenProps {
  title: string;
  message: string;
  stateAttribute: "data-platform-auth-state" | "data-platform-loading-state";
  authStatus?: string;
  showProgress?: boolean;
  actionLabel?: string;
  onAction?: () => void;
}

export function LoadingStateScreen({
  title,
  message,
  stateAttribute,
  authStatus,
  showProgress = true,
  actionLabel,
  onAction
}: LoadingStateScreenProps): JSX.Element {
  return (
    <main
      {...{ [stateAttribute]: "" }}
      {...(authStatus ? { "data-auth-status": authStatus } : {})}
    >
      <section data-platform-loading-card="" aria-live="polite">
        <img data-platform-loading-mark="" src="/logos/logo-mini.png" alt="KoreNext" />
        <p data-platform-loading-eyebrow="">KORENEXT PLATFORM</p>
        <h1 data-platform-auth-title="">{title}</h1>
        <p data-platform-auth-body="">{message}</p>
        {showProgress ? (
          <div data-platform-loading-progress="" aria-hidden="true">
            <span />
          </div>
        ) : null}
        {actionLabel && onAction ? (
          createElement(
            "tc-button",
            { variant: "brand", "data-platform-loading-action": "", onClick: onAction },
            actionLabel
          )
        ) : null}
      </section>
    </main>
  );
}
